import { gspx } from '@rsos/gainsight';

export const addSatelliteButtonClickListener = () => {
  let satelliteButton = document.querySelector(
    '[aria-label="Show satellite imagery"]',
  );
  if (satelliteButton) {
    satelliteButton.addEventListener('click', () => {
      gspx.trackCustomEvent('Data Map', {
        name: 'Switch to satellite view',
        Category: 'Google Map',
        'Launched date': new Date(),
      });
    });
  }
};

export const addZoomInButtonClickListener = () => {
  let zoomInButton = document.querySelector('[aria-label="Zoom in"]');
  if (zoomInButton) {
    zoomInButton.addEventListener('click', () => {
      gspx.trackCustomEvent('Data Map', {
        name: 'Zoom in',
        Category: 'Google Map',
        'Launched date': new Date(),
      });
    });
  }
};

export const addZoomOutButtonClickListener = () => {
  let zoomOutButton = document.querySelector('[aria-label="Zoom out"]');
  if (zoomOutButton) {
    zoomOutButton.addEventListener('click', () => {
      gspx.trackCustomEvent('Data Map', {
        name: 'Zoom out',
        Category: 'Google Map',
        'Launched date': new Date(),
      });
    });
  }
};
